import { render, staticRenderFns } from "./AccidentReportIndex.vue?vue&type=template&id=6af7ac1a&scoped=true&"
import script from "./AccidentReportIndex.vue?vue&type=script&lang=js&"
export * from "./AccidentReportIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af7ac1a",
  null
  
)

export default component.exports